import { MathJaxContext } from 'better-react-mathjax'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { store } from '@/store'
import '@assets/scss/main.scss'
import { ConfirmPopupProvider } from '@context/confirmPopupContext'
import { HeaderContextProvider } from '@context/headerContext'

import App from './App'
import reportWebVitals from './reportWebVitals'
import './wdyr'

const container = document.getElementById('root')!
const root = createRoot(container)

const config = {
  loader: { load: ['[tex]/html'] },
  tex: {
    packages: { '[+]': ['html'] },
    inlineMath: [
      ['$', '$'],
      ['\\(', '\\)'],
    ],
    displayMath: [
      ['$$', '$$'],
      ['\\[', '\\]'],
    ],
  },
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfirmPopupProvider>
        <HeaderContextProvider>
          <MathJaxContext
            version={3}
            config={config}
          >
            <App />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              closeButton={false}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss={false}
              draggable={false}
              pauseOnHover={false}
              theme="light"
            />
          </MathJaxContext>
        </HeaderContextProvider>
      </ConfirmPopupProvider>
    </Provider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
